import { render } from "./MainBox.vue?vue&type=template&id=285e3278&scoped=true"
import script from "./MainBox.vue?vue&type=script&lang=js"
export * from "./MainBox.vue?vue&type=script&lang=js"

import "./MainBox.vue?vue&type=style&index=0&id=285e3278&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285e3278"]])

export default __exports__